import React, { FC } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { BusinessOutlined, PersonOutlined, QuestionMarkOutlined, Description, ShoppingBagOutlined, WidgetsOutlined } from '@mui/icons-material';

const TaxonomyTypeRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {
    const value = props.value?.toLowerCase();
    const iconMap = {
        'person': <PersonOutlined />,
        'organization' : <BusinessOutlined />,
        'thing': <WidgetsOutlined />,
        'product': <ShoppingBagOutlined />,
        'document': <Description />,
    }
    return <div className="icon-renderer-cell">
        {iconMap[value] || <WidgetsOutlined />}
    </div>
};

export default TaxonomyTypeRenderer;
